import styled from "styled-components";

export const LogoWrapper = styled("div")<{
  $gap: number;
  $inline: boolean;
}>`
  display: inline-flex;
  align-items: center;
  gap: ${({ $gap }) => $gap}px;
  flex-direction: ${({ $inline }) => ($inline ? "row" : "column")};
`;

export const LogoImage = styled("img")<{
  $size: number;
  $rounded: number;
}>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: ${({ $rounded }) => $rounded}px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const LogoName = styled("span")<{
  $size: "sm" | "md" | "lg";
  $variant: "light" | "dark";
}>`
  font-weight: 700;
  color: ${({ $variant }) => ($variant === "light" ? "#e2e8f0" : "#0f172a")};
  letter-spacing: -0.02em;
  line-height: 1.2;

  ${({ $size }) =>
    $size === "sm" &&
    `
    font-size: 0.95rem;
  `}

  ${({ $size }) =>
    $size === "md" &&
    `
    font-size: 1.25rem;
  `}

  ${({ $size }) =>
    $size === "lg" &&
    `
    font-size: 1.75rem;
  `}
`;
